import React  from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import aoLogo from '../../assets/images/ao-logo.svg';
import showPasswordIcon from '../../assets/images/unmask-icon.svg';
import hidePasswordIcon from '../../assets/images/mask-icon.svg';
import dataModel from '../../models/DataModel';
import SessionManager from '../../helpers/session/SessionManager';
import PasswordSecurity from '../../components/PasswordSecurity';

import './SetPassword.scss';
import Input from '../../components/Input';

class SetPassword extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      passwordMessage: '',
      confirmMessage: '',
      passwordStrongEnough: false,
      passwordFocus: false,
      confirmPasswordFocus: false,
      showPassword: false,
      showConfirmPassword: false,
      suggestions: [],
      warning: '',
    };

    this.updatePasswordStrength = this.updatePasswordStrength.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  handlePasswordChange(event) {
    let password = event.target.value;
    this.setState({ password });  
  }

  updatePasswordStrength(passwordStrongEnough) {
    this.setState({ passwordStrongEnough });
  }  

  handleConfirmPasswordChange(event) {
    let confirmPassword = event.target.value;
    let confirmPasswordMessage = '';
    let match = false;
    if (confirmPassword.length > 0) {
      confirmPasswordMessage = this.textMap.password8Characters;
      if (confirmPassword.length >= 8) {
        confirmPasswordMessage = this.textMap.passwordsMustMatch;
        if (confirmPassword == this.state.password) {
          match = true;
          confirmPasswordMessage = '';
        }
      }
    }
    this.setState({
      match: match,
      confirmPassword: confirmPassword,
      confirmMessage: confirmPasswordMessage,
    });
  }

  handleFocusPassword() {
    this.setState({
      passwordFocus: true,
      passwordActiveFocus: true,
    });
  }

  handleBlurPassword() {
    if (!this.state.password) {
      this.setState({ passwordFocus: false });
    }
  }

  handleFocusConfirmPassword() {
    this.setState({
      confirmPasswordFocus: true,
      confirmPasswordActiveFocus: true,
    });
  }

  handleBlurConfirmPassword() {
    if (!this.state.confirmPassword) {
      this.setState({ confirmPasswordFocus: false });
    }
  }

  handleShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }

  handleShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  handleKeyDown(event) {
    if (event.keyCode == 13) {
      if (this.state.match) {
        this.handleSetPassword();
      }
    }
  }

  handleSetPassword() {
    dataModel.usersDAO.setPassword(this.state.password, this.props.match.params.token).then(response => {
      if (response.error) {
        this.setState({ error: true });
      }
      else {
        SessionManager.login(this.props.match.params.email, this.state.password, false)
          .then((user) => {
            this.props.dataModel.displayInfoErrorMessage(
              'Password successfully set.',
              4000,
              1
            );
            if (!this.props.dataModel.mobileBridge.isMobile) {
              if (!user.role_name || user.role_name == 'standard_user') {
                this.props.history.replace('/tasks/project/all');
              }
              else {
                this.props.history.replace('/projects/summary');
              }
            }
            else {
              this.props.history.replace('/mobile');
            }
          })
          .catch(error => {
            this.props.dataModel.displayInfoErrorMessage(
              'Error setting password: ' + error.message,
              4000,
              2
            );
          });
      }
    });
  }

  handleDismissMessage() {
    this.handledMessageDisplay = true;
  }

  render() {

    let confirmPasswordInput, matchMessage;

    if (this.state.passwordStrongEnough) {
      let unmaskIcon = this.state.confirmPassword ? (
        <img
          onClick={this.handleShowConfirmPassword}
          className="show-password-icon"
          src={
            this.state.showConfirmPassword ? hidePasswordIcon : showPasswordIcon
          }
          alt=""
        />
      ) : null;

      confirmPasswordInput = (
        <div
          className={
            this.state.confirmPasswordFocus
              ? 'login-confirm-password mat-div is-active is-completed'
              : 'login-confirm-password mat-div'
          }
        >
          <label className="login-label mat-label" htmlFor="password">
            {'CONFIRM PASSWORD'}
          </label>
          <Input
            className="login-input mat-input"
            id="confirm-password"
            onKeyDown={this.handleKeyDown}
            onFocus={this.handleFocusConfirmPassword}
            onBlur={this.handleBlurConfirmPassword}
            onChange={this.handleConfirmPasswordChange}
            type={this.state.showConfirmPassword ? 'text' : 'password'}
          />
          {unmaskIcon}
        </div>
      );
    }

    let passwordUnmaskIcon = this.state.password ? (
      <img
        onClick={this.handleShowPassword}
        className="show-password-icon"
        src={this.state.showPassword ? hidePasswordIcon : showPasswordIcon}
        alt=""
      />
    ) : null;

    let button = this.state.match ? (
      <button className="login-button" onClick={this.handleSetPassword}>
        {' '}
        LOG IN{' '}
      </button>
    ) : (
      <button className="login-button disabled"> LOG IN </button>
    );
    let errorMessage;
    if (this.state.error) {
      errorMessage = (
        <div className="login-error-message">
          Your set password attempt has failed. Please contact your
          administrator.
        </div>
      );
    }
    return (
      <div className="set-password-screen">
        <section className="login-form">
          <img className="login-logo" src={aoLogo} alt="logo" />
          <div className="login-message">
            {this.textMap.createYourPassword}
          </div>
          <div
            id="password-container"
            className={
              this.state.passwordFocus
                ? 'login-password mat-div is-active is-completed'
                : 'login-password mat-div'
            }
           >
            <label className="login-label mat-label" htmlFor="password">
              {this.state.passwordFocus ? 'PASSWORD' : 'ENTER A PASSWORD'}
            </label>
            <Input
              className="login-input mat-input"
              id="password"
              onKeyDown={this.handleKeyDown}
              onFocus={this.handleFocusPassword}
              onBlur={this.handleBlurPassword}
              onChange={this.handlePasswordChange}
              type={this.state.showPassword ? 'text' : 'password'}
            />
            {passwordUnmaskIcon}
          </div>
          <PasswordSecurity
            password1={this.state.password}
            updatePasswordStrength={this.updatePasswordStrength}
          />
          {confirmPasswordInput}
          {matchMessage}
          {errorMessage}
          {button}
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    mobileBridge: dataModel.mobileBridge,
  };
};

export default withRouter(connect(mapStateToProps)(SetPassword));



// WEBPACK FOOTER //
// ./src/containers/SetPassword/index.js